import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function Competitors() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", handle: "", url: "", category: "direct" });

  const load = () => api.get("/competitors").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name) return;
    await api.post("/competitors", form);
    setForm({ name: "", handle: "", url: "", category: "direct" });
    toast.success("Competitor added");
    load();
  };

  const remove = async (id) => { await api.delete(`/competitors/${id}`); load(); };

  const grouped = items.reduce((acc, c) => { (acc[c.category] = acc[c.category] || []).push(c); return acc; }, {});

  return (
    <div className="p-8 max-w-[1400px]">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold mb-1">Competitors</div>
        <h1 className="text-5xl font-black tracking-tight leading-none" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Watchlist</h1>
        <p className="text-sm text-neutral-600 mt-2">Data collected via approved sources only. Automated engagement estimates are labelled as proxies, not truth.</p>
      </div>

      <div className="bg-white border border-neutral-200 rounded-lg p-4 mb-6 flex flex-wrap gap-2 items-end">
        <input data-testid="comp-name" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm" />
        <input data-testid="comp-handle" placeholder="@handle" value={form.handle} onChange={(e) => setForm({ ...form, handle: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm" />
        <input data-testid="comp-url" placeholder="URL" value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm flex-1 min-w-[200px]" />
        <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm">
          <option value="direct">Direct</option>
          <option value="adjacent">Adjacent</option>
          <option value="content_inspiration">Content inspiration</option>
          <option value="founder_reference">Founder reference</option>
          <option value="running_community">Running community</option>
          <option value="global_benchmark">Global benchmark</option>
        </select>
        <button data-testid="add-comp-btn" onClick={add} className="px-4 py-2 rounded font-semibold text-sm text-neutral-900 flex items-center gap-1" style={{ background: "#D4FF00" }}><Plus className="w-3 h-3" />Add</button>
      </div>

      {Object.entries(grouped).map(([cat, list]) => (
        <div key={cat} className="mb-6">
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold mb-2">{cat.replace(/_/g, " ")}</div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {list.map((c) => (
              <div key={c.id} data-testid={`comp-${c.id}`} className="bg-white border border-neutral-200 rounded p-4 flex items-start justify-between">
                <div>
                  <div className="font-semibold">{c.name}</div>
                  <div className="text-xs text-neutral-500">{c.handle}</div>
                  <div className="text-xs text-neutral-500 mt-1">{c.followers_snapshot?.toLocaleString()} followers</div>
                </div>
                <button data-testid={`del-comp-${c.id}`} onClick={() => remove(c.id)} className="text-xs text-neutral-500 hover:text-red-600">Remove</button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
